import { useEffect } from "react";
import type { NextRouter } from "next/router";

export function useStepEmailRouterSync(params: {
	router: NextRouter;
	emailQuery: string | undefined;
	errorParam: string | undefined;
	openErrorModal: (index: number) => void;
	setPrefilledEmail: (email: string) => void;
}): void {
	const { router, emailQuery, errorParam, openErrorModal, setPrefilledEmail } = params;

	// Deps use emailQuery / errorParam (not router.query) so the effect does not re-run on a new query object reference only.
	useEffect(() => {
		if (!router.isReady) return;
		if (emailQuery) setPrefilledEmail(emailQuery);
		if (!errorParam) {
			openErrorModal(0);
			return;
		}
		const parsedError = Number.parseInt(errorParam, 10);
		if (!Number.isNaN(parsedError)) openErrorModal(parsedError);
	}, [emailQuery, errorParam, router.isReady, openErrorModal, setPrefilledEmail]);
}
